import uiActions from '../actions/UIActions';
import reducerUtils from './ReducerUtils';
import UIConstants from '../constants/UIConstants';
import uiService from '../services/UIService';

const defaultState = {
    zoomFactor: UIConstants.ZOOM_FACTOR.SMALL,
    variables: {},
    a11yContrastOptions: uiService.readAccessibilityContrastOptions(),
    direction: 'ltr',
    pciResourceOverlays: {},
};

export default function (state = defaultState, action) {
    switch (action.type) {
    case uiActions.types.UI_SET_PROPERTIES:
        return reducerUtils.applyProps(state, action.properties);
    case uiActions.types.UI_UPDATE_PCI_OVERLAY: {
        const { contentItemId, patch, remove } = action;
        const overlays = state.pciResourceOverlays || {};
        if (remove) {
            if (!Object.prototype.hasOwnProperty.call(overlays, contentItemId)) {
                return state;
            }
            const { [contentItemId]: _removed, ...rest } = overlays;
            return { ...state, pciResourceOverlays: rest };
        }
        const existing = overlays[contentItemId];
        if (!existing && !patch?.resource) {
            return state;
        }
        return {
            ...state,
            pciResourceOverlays: {
                ...overlays,
                [contentItemId]: { ...existing, ...patch },
            },
        };
    }
    case uiActions.types.SET_STIMULUS_STATE:
        return {
            ...state,
            stimulusState: action.state,
        };
    default:
        return state;
    }
}
